const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

import { formatToURL } from "./utils/formatToURL";

const menu = {
  computed: {
    schoolPages() {
      return this.$rest("school-pages")
        .list.filter(({ title }) => !!title)
        .map(({ title }) => ({
          text: title,
          to: `/a-facem/${formatToURL(title)}`,
        }));
    },
    student() {
      return this.$rest("student")
        .list.filter(({ title }) => !!title)
        .map(({ attachments, title, text }) => {
          const item = {
            text: title,
          };

          if (!text && attachments.length == 1)
            item.to = this.server + attachments[0].path;
          else item.to = `/academicos/${formatToURL(title)}`;

          return item;
        });
    },
    cpa() {
      return this.$rest("cpa")
        .list.filter(({ title }) => !!title)
        .map(({ attachments, title, text }) => {
          const item = {
            text: title,
          };

          if (!text && attachments.length == 1)
            item.to = this.server + attachments[0].path;
          else item.to = `/cpa/${formatToURL(title)}`;

          return item;
        });
    },
    research() {
      return this.$rest("research")
        .list.filter(({ title }) => !!title)
        .map(({ attachments, title, text }) => {
          const item = {
            text: title,
          };

          if (!text && attachments.length == 1)
            item.to = this.server + attachments[0].path;
          else item.to = `/pesquisa-e-extensao/${formatToURL(title)}`;

          return item;
        });
    },
    selection() {
      return this.$rest("selection")
        .list.filter(({ title }) => !!title)
        .map(({ title, text, url }) => {
          const item = {
            text: title,
          };

          if (!text && url.length > 1) item.to = url;
          else item.to = `/processo-seletivo/${formatToURL(title)}`;

          return item;
        });
    },
    courses() {
      return this.$rest("courses")
        .list.filter(({ title }) => !!title)
        .map(({ title }) => ({
          text: title,
          to: `/cursos/${formatToURL(title)}`,
        }));
    },
    regulations() {
      return this.$rest("regulations")
        .list.filter(({ title }) => !!title)
        .map(({ attachments, title, text }) => {
          const item = {
            text: title,
          };

          if (!text && attachments.length == 1)
            item.to = this.server + attachments[0].path;
          else item.to = `/regulamentos/${formatToURL(title)}`;

          return item;
        });
    },
    menu() {
      return [
        {
          text: "A FACEM",
          dropdown: [
            {
              text: "Equipe de apoio",
              to: "/a-facem/equipe-de-apoio",
            },
            ...this.schoolPages,
            {
              text: "Estrutura",
              to: "/a-facem/estrutura",
            },
          ],
        },
        {
          text: "Acadêmicos",
          dropdown: this.student,
        },
        {
          text: "CPA",
          dropdown: this.cpa,
        },
        {
          text: "Cursos",
          dropdown: this.courses,
        },
        {
          text: "Galeria",
          to: "/galerias-de-fotos",
        },
        {
          text: "Pesquisa e extensão",
          dropdown: this.research,
        },
        {
          text: "Processo Seletivo",
          dropdown: this.selection,
        },
        {
          text: "Regulamentos",
          dropdown: this.regulations,
        },
      ];
    },
  },
  created() {
    this.$rest("school-pages").get();
    this.$rest("student").get();
    this.$rest("cpa").get();
    this.$rest("courses").get();
    this.$rest("research").get();
    this.$rest("selection").get();
    this.$rest("regulations").get();
  },
};

export { server, menu };
